export default "__VITE_PUBLIC_ASSET__77aa35b0__"